export const buttonStyles = () => ({
    color: 'black',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    transition: 'all 0.2s ease',
      fontSize: '0.8rem',
    '& .MuiButton-startIcon': {
        margin:0,
    '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
        },
    },
    '& .MuiButton-endIcon': {
        margin:0,
    '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
        },
    },
    '&:hover': {
      fontSize: '0.85rem',
      boxShadow: '0 4px 4px rgba(0, 0, 10, 0.6)', 
    },
});
  
export const middlebuttonStyles = () => ({
    color: 'black',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
    fontSize: '1.4rem',
    '& .MuiButton-startIcon': {
    '& .MuiSvgIcon-root': {
        fontSize: '1.5rem',
        },
    },
    '&:hover': {
      
    },
  });